import { createPromiseControllers } from '../../../common/v5/helpers';
import { clearInsertionText, insertText } from '../cke';
import { wrapProtectReplyContentMarker } from '../common';

const [
    insertionTextStart
    , insertionTextControl
] = createPromiseControllers();

export const insertContent = text => dispatch => {
    const p = insertionTextStart(true);
    

    if (typeof text === 'string' && text.indexOf('<') !== -1) {

        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = text;
        

        const elementsWithStyle = tempDiv.querySelectorAll('[style*="font-family"], [style*="font-size"]');
        
    
        elementsWithStyle.forEach(el => {
            const style = el.getAttribute('style');
            if (style) {
              
                const newStyle = style
                    .replace(/font-family\s*:\s*[^;]+;?/gi, '')
                    .replace(/font-size\s*:\s*[^;]+;?/gi, '')
                    .trim();
                
                if (newStyle) {
                    el.setAttribute('style', newStyle);
                } else {
                    el.removeAttribute('style');
                }
            }
        });
        

        const fontTags = tempDiv.querySelectorAll('font[face], font[size]');
        fontTags.forEach(font => {
            font.removeAttribute('face');
            font.removeAttribute('size');
        });
        

        dispatch(insertText(tempDiv.innerHTML));
    } else {

        dispatch(insertText(text));
    }
    return p;
};

export const insertProtectedReplyContent = text => (
	dispatch
	, getState
) => dispatch(insertContent(wrapProtectReplyContentMarker(text, getState())));

export const clearInsertionContent = () => dispatch => {
    dispatch(clearInsertionText());
    insertionTextControl();
};
